module.exports = __webpack_public_path__ + "static/financial-access-mobile.8d841df5.webp";